const DOM = {
  rechargeApp: '#ReCharge',
  sidebar: '#rc_navigation',
  name: '.rc_customer__name',
  inputWrapper: '.form-group.input-wrapper',
};

/**
 * Update all form inputs
 */
const updateFormInputs = () => {
  const inputWrappers = document.querySelectorAll(DOM.inputWrapper);

  inputWrappers.forEach((wrapper) => {
    const label = wrapper.querySelector('label');
    const input = wrapper.querySelector('input');
    const select = wrapper.querySelector('select') || false;

    if (input && input.getAttribute('type') === 'checkbox') {
      wrapper.classList.add('input', 'input--check');
    } else {
      wrapper.classList.add('input', 'input--text');
    }

    if (select === false) {
      // was seeing errors, so put in these checks
      if (input) {
        input.setAttribute('placeholder', ' ');
      }
      
      if (label){
        wrapper.appendChild(label);
      }
      
    }
  });
};

const insertAfter = (newNode, existingNode) => {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
};

/**
 * Adds a "Back To Account" link to the subscription dashboard sidebar
 */
const addSidebarItem = () => {
  const name = document.querySelector(DOM.name);
  const newItem = document.createElement('a');
  newItem.innerHTML = 'Back To Account';
  newItem.setAttribute('href', '/account/');
  newItem.classList.add('back-to-account');
  insertAfter(newItem, name);
};

const checkForActiveItem = () => {
  const activeItem = document.querySelector('.rc_menu__item.rc_active') || false;
  if (activeItem) return;
  // set new active item if one isn't found
  const activeLink = document.querySelector(`.rc_menu__item a[href="${window.location.href}"]`);
  activeLink.parentNode.classList.add('rc_active');
};

/**
 * Checks if the recharge dashboard is on the current page, and runs setup if it is
 */
const setup = () => {
  const rechargeAppEl = document.querySelector(DOM.rechargeApp) || false;
  if (!rechargeAppEl) return;

  addSidebarItem();
  updateFormInputs();
  checkForActiveItem();
};

export default {
  setup,
};
